var _circle, _path, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpportunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#52D783"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1006 6.29596L11.4676 6.29596L11.4582 8.28656C11.4582 8.64432 11.7599 8.93786 12.1276 8.93786C12.4953 8.93786 12.797 8.64432 12.797 8.28656L12.7876 6.29596L14.1547 6.29596C14.4469 6.29596 14.5978 5.94738 14.3856 5.74098L12.3633 3.77331C12.2313 3.64488 12.0239 3.64488 11.8919 3.77331L9.86959 5.74098C9.65745 5.94738 9.8083 6.29596 10.1006 6.29596ZM6.47076 13.7722L6.47076 12.4421L8.51666 12.4512C8.88435 12.4512 9.18605 12.1577 9.18605 11.7999C9.18605 11.4422 8.88435 11.1486 8.51666 11.1486L6.47076 11.1578L6.47076 9.82767C6.47076 9.5433 6.11249 9.39653 5.90036 9.60293L3.87804 11.5706C3.74604 11.699 3.74604 11.9008 3.87804 12.0293L5.90036 13.9969C6.11249 14.2033 6.47076 14.0566 6.47076 13.7722ZM14.1547 17.3039L12.7876 17.3039L12.797 15.3133C12.797 14.9555 12.4953 14.662 12.1276 14.662C11.7599 14.662 11.4582 14.9555 11.4582 15.3133L11.4676 17.3039L10.1006 17.3039C9.80831 17.3039 9.65746 17.6525 9.86959 17.8589L11.8919 19.8265C12.0239 19.955 12.2313 19.955 12.3633 19.8265L14.3856 17.8589C14.5978 17.6525 14.4469 17.3039 14.1547 17.3039ZM17.7845 9.82767L17.7845 11.1578L15.7386 11.1486C15.3709 11.1486 15.0692 11.4422 15.0692 11.7999C15.0692 12.1577 15.3709 12.4512 15.7386 12.4512L17.7845 12.4421L17.7845 13.7722C17.7845 14.0566 18.1427 14.2033 18.3549 13.9969L20.3772 12.0293C20.5092 11.9008 20.5092 11.699 20.3772 11.5706L18.3549 9.60293C18.1427 9.39653 17.7845 9.5433 17.7845 9.82767Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 11.6758,
    rx: 4,
    ry: 3.89189,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9999,
    cy: 11.6756,
    rx: 2.66667,
    ry: 2.59459,
    fill: "#52D783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunity);
export default __webpack_public_path__ + "static/media/opportunity.d9f23938d13b43bdbae044101677e34f.svg";
export { ForwardRef as ReactComponent };